import React from 'react';
import { Grid, Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import { styles } from './confirmation-panel-styles';

// eslint-disable-next-line @typescript-eslint/naming-convention, react/function-component-definition
const ConfirmationDialogPanel = props => {
  const {
    classes,
    open,
    title,
    content,
    maxWidth = 'md',
    backdropClick,
    cancelText,
    continueText,
    onCancel,
    onContinue,
    showCancelButton = true,
    styleOverrides = {},
    componentOverrides = {},
    disableCancelButton = false,
    disableContinueButton = false,
  } = props;

  return (
    <Dialog open={open} maxWidth={maxWidth} onBackdropClick={backdropClick}>
      {title && <DialogTitle className={classes.confirmationDialogTitle}>{title}</DialogTitle>}
      <DialogContent>{content}</DialogContent>
      <DialogActions>
        <Grid
          container
          style={
            styleOverrides.buttonContainer
              ? { ...styleOverrides.buttonContainer }
              : { justifyContent: 'flex-end' }
          }
        >
          {showCancelButton ? (
            <Grid item>
              <Button
                variant={componentOverrides.noButtonVariant}
                onClick={onCancel}
                disabled={disableCancelButton}
              >
                {cancelText}
              </Button>
            </Grid>
          ) : null}
          <Grid item>
            <Button
              color="primary"
              variant="contained"
              onClick={onContinue}
              className={classes.confirmationContinueButton}
              disabled={disableContinueButton}
            >
              {continueText}
            </Button>
          </Grid>
        </Grid>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles, { withTheme: true })(ConfirmationDialogPanel);
